import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sent-tab-no-active-service',
  templateUrl: './sent-tab-no-active-service.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./sent-tab-no-active-service.component.scss'],
})
export class SentTabNoActiveServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
